<template>
    <div class="container-fluid imputazioni table-responsive" v-if="ready">
        <table id="dataTable" class="table table-hover stickedtable">
            <thead>
            <tr>
                <th>&nbsp;</th>
                <th class="text-left" v-for="(busta,n) in bustejson">
                    {{ busta.year }}/{{ busta.month }}
                </th>
                <th class="">&nbsp;</th>
            </tr>
            <tr>
                <th style="max-width: 200px;">Buste paga</th>
                <th class="text-left" v-for="(busta,n) in bustejson">
                    <b v-tooltip="'Ore lavorate busta paga'">{{ busta.lulhours }}</b>
                </th>

                <th class="">Tot.</th>
            </tr>
            <tr>
                <th style="max-width: 200px;">Progetti e Voce di costo</th>
                <th v-for="(mese) in months" class="text-left">
                    <v-btn @click="modificaImputazione(totalimese[mese].busta_id)" icon solo
                           v-tooltip="'modifica imputazione'">
                        <i class="glyphicon glyphicon-edit"></i>
                    </v-btn>
                    <span style="color:blue;" v-tooltip="'Totale ore imputate'">{{
                            totalimese[mese].valore
                        }}</span><br/>
                </th>
                <th class="">Tot.</th>
            </tr>
            </thead>
            <tbody>
            <tr class="" v-for="imputazione in imputazioni">
                <td class="text-left" style="padding-top: 1px;">
                    <b>{{ getProgetto(imputazione.progetto_id) }}</b><br/>
                    <span :class="'vdc_'+imputazione.vocedicosto.replace('.','').toUpperCase().trim()">{{
                            getVoceDiCosto(imputazione.vocedicosto)
                        }}</span>
                </td>
                <td class="text-left" v-for="(busta,n) in imputazione.monthretributions" :data-pid="imputazione.progetto_id" :data-month="busta.monthkey">
                    <v-text-field
                        v-model="busta.valore"
                        type="number"
                        hide-details
                        solo
                        label="H/m"
                    ></v-text-field>
                    <em v-if="isRegistroVoice(imputazione.vocedicosto)"
                        v-tooltip="'Ore inserite nel registro didattico'">({{ busta.tsvalue }})</em>
                    <em v-if="hasLogbookRecord(busta.monthkey, imputazione.progetto_id)"
                        v-tooltip="'Ore inserite nel registro didattico, Generiche'">[{{ getLogbookRecord(busta.monthkey, imputazione.progetto_id) }}]</em>
                </td>
                <td class="bold text-right">
                    {{ imputazione.total }}
                    <em v-if="isRegistroVoice(imputazione.vocedicosto)"
                        v-tooltip="'Differenza tra imputato e registro'">({{ imputazione.diff }})</em>
                </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td style="padding-top: 1px;">Totali</td>
                <td v-for="(mese) in months" class="text-left">
                    <b style="color:blue;" v-tooltip="'Totale ore imputate'">{{ totalimese[mese].valore }}</b><br/>
                    <v-btn @click="modificaImputazione(totalimese[mese].busta_id)" icon solo>
                        <i class="glyphicon glyphicon-edit"></i>
                    </v-btn>
                    <v-btn @click="saveImputazione(totalimese[mese].busta_id, mese)" icon solo>
                        <i class="glyphicon glyphicon-floppy-save"></i>
                    </v-btn>
                </td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td style="max-width: 200px;">Buste paga</td>
                <td class="text-left" v-for="(busta,n) in bustejson">
                    <b v-tooltip="'Ore lavorate busta paga'">{{ busta.lulhours }}</b>
                </td>
                <td class="">Tot.</td>
            </tr>
            </tfoot>
        </table>
        <div>
            <em>Le prime due righe sono riferite alle buste paga (totale ore da LUL)<br/></em>
            <em>Il valore tra parentesi rappresenta le ore svolte su registro<br/></em>
            <em>L'ultima riga rappresenta il totale imputato<br/></em>
            <p>In questa pagina non è possibile modificare i tipi di imputazione o aggiungerne di nuovi, tuttavia si
                possono variare i valorix delle singole imputazioni esistenti.</p>
        </div>
    </div>
</template>
<style>
.vdc_B13, .vdc_B21, .vdc_B22 {
    color: darkmagenta;
}

.vdc_B23, .vdc_B24 {
    color: slateblue;;
}

.vdc_B25, .vdc_B26 {
    color: darkslategrey;
}

.vdc_B41 {
    color: darkred;
}

.vdc_B42 {
    color: darkblue;
}

.vdc_B43 {
    color: darkslateblue;;
}

.vdc_B44, .vdc_B45 {
    color: purple;
}


.imputazioni .v-menu__content {
    width: fit-content;
    max-width: fit-content;
}

.imputazioni .v-messages,
.imputazioni .v-text-field__details {
    display: none;
}

.imputazioni .col-md-6,
.imputazioni .col-md-3,
.imputazioni .col-md-4,
.imputazioni .col-md-2,
.imputazioni .col-md-1 {
    margin-bottom: 2px;
    padding-bottom: 3px;
    border-bottom: 1px solid #ccc;
}

.imputazioni .col-md-half {
    margin-bottom: 2px;
    padding-bottom: 3px;
    border-bottom: 1px solid #ccc;
    min-width: calc(100% / 24);
    width: auto;
    max-width: calc(100% / 12);
}

.imputazioni .col-md-1,
.imputazioni .totali .col-md-2 {
    display: flex;
    align-items: center;
    align-content: center;
}
</style>
<script>
const _vocidicosto = [
    {'value': 'B1.3', "text": 'B1.3 Elaborazione testi didattici e dispense'},
    {'value': 'B2.1', "text": 'B2.1 Docenza interna'},
    {'value': 'B2.2', "text": 'B2.2 Docenza esterna'},
    {'value': 'B2.3', "text": 'B2.3 Docenza di supporto/codocenza interna'},
    {'value': 'B2.4', "text": 'B2.4 Docenza di supporto/codocenza esterna'},
    {'value': 'B2.5', "text": 'B2.5 Tutoraggio interno'},
    {'value': 'B2.6', "text": 'B2.6 Tutoraggio esterno'},
    {'value': 'B2.8', "text": 'B2.8 Orientamento esterno'},
    {'value': 'B2.9', "text": 'B2.9 Attività di sostegno all\'utenza svantaggiata interna'},
    {'value': 'B2.10', "text": 'B2.10 Attività di sostegno all\'utenza svantaggiata esterna'},
    {'value': 'B4.1', "text": 'B4.1 Direzione progetto'},
    {'value': 'B4.2', "text": 'B4.2 Coordinamento'},
    {'value': 'B4.3', "text": 'B4.3 Attività amministrativa'},
    {'value': 'B4.4', "text": 'B4.4 Costi di monitoraggio interno'},
    {'value': 'B4.5', "text": 'B4.5 Costi di monitoraggio esterno'}
];
const _registroVoices = [
    'B2.1',
    'B2.2',
    'B2.5',
    'B2.6'
]

export default {
    props: {
        "docenteid": "",
        "progettiurl": "",
        "editurl": "",
        "saveurl": "",
        "from": null,
        "to": null,
        "orelavorate": "",
        "months": {
            type: Array,
            default: () => []
        },
        "logbookrecords": {
            type: Object,
            default: () => {}
        },
        "imputazionijson": {
            type: Array,
            default: () => []
        },
        "bustejson": {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            "percentuale": 0,
            "imputazioni": [],
            'progetti': [],
            "totalimese": [],
            'ready': false
        }
    },
    computed: {
        vocidicosto() {
            return _vocidicosto
        },
        vociregistro() {
            return _registroVoices
        }
    },
    watch: {
        imputazioni: {
            handler(oldval, newval) {
                if (this.ready) {
                    console.log('qualocsa cambia')
                    this.updateMonthRetributionTotals()
                }
            },
            deep: true
        }
    },
    methods: {
        hasLogbookRecord(monthKey,pid) {
            if(typeof this.logbookrecords[monthKey] ==='undefined') {
                return false;
            }
            if(typeof  this.logbookrecords[monthKey][pid] !=='undefined') {
                return true;
            }
            return false;
        },
        getLogbookRecord(monthKey,pid) {
            if(!this.hasLogbookRecord(monthKey,pid)) {
                return 0;
            }
            if(typeof  this.logbookrecords[monthKey][pid] !=='undefined') {
                return (this.logbookrecords[monthKey][pid]);
            }
            return 0;

        },
        updateMonthRetributionTotals() {
            this.months.forEach((item) => {
                this.totalimese[item].valore = 0;
            })
            this.imputazioni.map((imputazione) => {
                let totale = 0;
                let diff = 0;
                const _monthKeys = Object.keys(imputazione.monthretributions);
                _monthKeys.map((key) => {
                    const mt = imputazione.monthretributions[key];
                    totale += parseFloat(mt.valore);
                    this.totalimese[key].valore += parseFloat(mt.valore);
                })

                imputazione.diff = totale - imputazione.tsvalues
                imputazione.total = totale;
            });
        },
        isRegistroVoice(voce) {
            return (this.vociregistro.indexOf(voce) > -1);
        },
        modificaImputazione(mr_id) {
            console.log('open Edit:', mr_id);
            const url = this.editurl.replace("SAVEID", mr_id);
            //Prepare Imputations for this


            window.open(url, '_blank');
        },
        saveImputazione(mr_id, mese) {

            if (typeof this.saveurl === 'undefined') {
                toastr.error('Impossibile salvare imputazioni ' + mese)
                return
            }
            if ((this.saveurl + "").length === 0) {
                toastr.error('Impossibile salvare imputazioni' + mese)
                return
            }

            const url = this.saveurl.replace('SAVEID', mr_id);

            console.log('save M ID::', mr_id, mese, url);
            let imputazioniMese = [];
            this.imputazioni.map((imputo) => {
                let _newImputazione = {
                    "progetto_id": imputo.progetto_id,
                    "vocedicosto": imputo.vocedicosto,
                    "workhours": 0
                }
                if (typeof imputo.monthretributions[mese] !== 'undefined') {
                    _newImputazione.workhours = parseFloat(imputo.monthretributions[mese].valore)
                }
                ;
                imputazioniMese.push(_newImputazione)
            });
            axios.post(url, imputazioniMese).then((result) => {
                if (result) {
                    if (result.data) {
                        toastr.success("Imputazioni " + mese + " salvate con successo")
                    } else {
                        toastr.error('Impossibile salvare imputazioni ' + mese)
                    }
                } else {
                    console.error(result)
                    toastr.error('Impossibile salvare imputazioni' + mese)
                }
            }).catch((error) => {
                console.error(error)
                toastr.error('Impossibile salvare imputazioni')
            })

        },
        getProgetto(id) {
            const filt = this.progetti.filter((v) => v.value == id);
            if (filt.length > 0) {
                return filt[0].text
            }
            return "-";
        },
        getVoceDiCosto(voce) {
            const filt = this.vocidicosto.filter((v) => v.value == voce);
            if (filt.length > 0) {
                return filt[0].text
            }
            return voce;
        },
        salvaImputazioni() {
            if (typeof this.saveurl === 'undefined') {
                toastr.error('Impossibile salvare imputazioni')
                return
            }
            if ((this.saveurl + "").length === 0) {
                toastr.error('Impossibile salvare imputazioni')
                return
            }
            axios.post(this.saveurl, this.imputazioni).then((result) => {
                if (result) {
                    console.log(result)
                    if (result.data) {
                        toastr.success("Impostazioni salvate con successo")
                    } else {
                        toastr.error('Impossibile salvare imputazioni')
                    }
                } else {
                    console.error(result)
                    toastr.error('Impossibile salvare imputazioni')
                }


            }).catch((error) => {
                console.error(error)
                toastr.error('Impossibile salvare imputazioni')
            })

        },

        addImputazione() {
            let _imputazione = {
                "progetto_id": "",
                "vocedicosto": "",
                "workhours": null,
                "amount": null,

                "monthretribution_id": this.monthretributionid
            };
            this.imputazioni.push(_imputazione);
        },

        retrieveProgetti() {
            if (typeof this.progettiurl === 'undefined') {
                toastr.error('Impossibile ottenere i progetti')
                return Promise.resolve()
            }
            if ((this.progettiurl + "").length === 0) {
                toastr.error('Impossibile ottenere i progetti')
                return Promise.resolve()
            }
            console.log(this.from, this.to)
            const start = parseInt(this.from)
            const end = parseInt(this.to)
            let years = [];
            for (var i = start; i <= end; i++) {
                years.push(i)
            }
            this.$set(this, 'progetti', []);
            return years.reduce((callback, value) => {
                return axios.get(this.progettiurl.replace('YEAR', value)).then((result) => {
                    console.log('got result' + value, result);
                    if (result && result.data) {
                        result.data.map((item) => {
                            this.progetti.push(item)
                        })
                    }
                });
            }, Promise.resolve()).finally(() => {
                console.log('tutti i progetti sono stati caricati')
                console.log('got projects?', this.progetti)
            });
        }
    },
    mounted() {
        console.log('Imputazioni montate', this.imputazionijson)

        if (typeof this.imputazionijson !== 'undefined') {
            this.months.forEach((item) => {
                this.totalimese[item] = {valore: 0, busta_id: -1};
            })
            if (Array.isArray(this.imputazionijson)) {
                this.imputazionijson.forEach((imputazione) => {
                    const newImputazione = {
                        "progetto_id": imputazione.progetto_id,
                        "vocedicosto": imputazione.vocedicosto,
                        "total": 0,
                        "tsvalues": 0,
                        "diff": 0,
                        "monthretributions": {}
                    }
                    this.months.forEach((mese) => {
                        const k = mese;
                        const buste = this.bustejson.filter((busta) => busta.monthkey == k);
                        if (buste.length > 0) {
                            if (buste.length > 1) {
                                console.warn("possibile errore 2 buste per il mese?")
                            }
                            const busta = buste[0];
                            let valore = 0;
                            let tsValue = 0;
                            const _imputo = busta.imputazioni.filter(imputa =>
                                imputa.vocedicosto == imputazione.vocedicosto &&
                                imputa.progetto_id == imputazione.progetto_id
                            )
                            if (_imputo.length > 0) {
                                _imputo.map(imp => {
                                    valore = parseFloat(imp.workhours)
                                    if (isNaN(valore)) {
                                        console.log('got nan?', imp.workhours, valore)
                                        valore = 0;
                                    }
                                    tsValue = parseFloat(imp.tsvalue)
                                    if (isNaN(tsValue)) {
                                        tsValue = 0;
                                    }
                                    newImputazione.total += valore
                                    newImputazione.tsvalues += tsValue
                                    this.totalimese[mese].valore += valore
                                    this.totalimese[mese].busta_id = busta.id
                                    this.totalimese[mese].monthkey = k
                                });
                            }
                            newImputazione.monthretributions[k] = {
                                "busta_id": busta.id,
                                "valore": valore,
                                "tsvalue": tsValue,
                                "monthkey":k
                            }
                        } else {
                            newImputazione.monthretributions[k] = {};
                        }
                    });
                    newImputazione.diff = newImputazione.total - newImputazione.tsvalues;
                    this.imputazioni.push(newImputazione);
                });
            }
        }
        console.log(this.imputazioni)
        this.retrieveProgetti().finally(() => {
            this.ready = true;
            setTimeout(function() {
                $('table.stickedtable').stickyTableHeaders({fixedOffset: $('.navbar-fixed-top')});
            },300);
        })
        window.test = this;

    }
}
</script>
